import {Component, OnChanges, OnInit} from '@angular/core';
import {HeadComponent} from "../../components/head/head.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {NgForOf, NgIf} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";
import {InvoiceCreatorComponent} from "./invoice-creator/invoice-creator.component";
import {InvoiceService} from "../../services/api/invoice/invoice.service";
import {InvoiceResponse} from "../../services/api/invoice/model";
import {ItemService} from "../../services/api/item/item.service";
import {formatDateToMMDDYYYY} from "../../utils/helper";
import {MatTooltip} from "@angular/material/tooltip";


@Component({
  selector: 'app-invoice-page',
  standalone: true,
  imports: [
    HeadComponent,
    MatButton,
    MatIconButton,
    NgIf,
    ReactiveFormsModule,
    FormsModule,
    NgForOf,
    MatIcon,
    MatTooltip,
    InvoiceCreatorComponent,
  ],
  templateUrl: './invoice-page.component.html',
  styleUrl: './invoice-page.component.css'
})
export class InvoicePageComponent implements OnInit, OnChanges {

  isCreating: boolean = false;
  invoiceList: InvoiceResponse[] = [];
  filteredInvoices: InvoiceResponse[] = [];

  constructor(
    private invoiceService: InvoiceService,
  ) {
  }

  ngOnInit() {
    this.getInvoices();
  }

  ngOnChanges() {
    this.getInvoices();
  }


  getInvoices() {
    this.invoiceService.getInvoices().subscribe(
      res => {
        this.invoiceList = res;
        this.filteredInvoices = res;
      }
    )
  }

  downloadInvoice(uuid: string): void {
    if (!uuid) return;

    this.invoiceService.getInvoiceFile(uuid).subscribe(
      (blob: Blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        window.open(fileURL, '_blank');

      },
      (error) => {
        console.error('Erreur lors de l’ouverture de la facture :', error);
      }
    );
  }

  searchResults(text: string) {
    this.filteredInvoices = text.trim() === ""
      ? this.invoiceList
      : this.invoiceList.filter(invoice => invoice.client_name.toLowerCase().includes(text.toLowerCase()));
  }

  protected readonly formatDateToMMDDYYYY = formatDateToMMDDYYYY;
}
